// EBUG-418 (causa da EBUG-297): o backend apaga e reinsere destinos frequentes, e-mails em cópia, dias
// fechados e dias com horário especial a cada gravação, então os ids que a tela guardou deixam de existir
// depois do primeiro "Salvar". Reenviados numa segunda gravação sem recarregar a página, davam
// "Unable to find ... with id ...". O backend não usa esses ids, e a tela deixa de mandá-los.
const FILHOS_REGRAVADOS = ['frequentFestinations', 'emailsCopy', 'operationCloseDays', 'operationSpecialDays'];

export function removeRewrittenChildIds(config: any): void {
  FILHOS_REGRAVADOS.forEach((lista) => (config[lista] || []).forEach((filho) => delete filho.id));
}
